<script lang="ts">
    import type { RendererRect } from "@utils/highlights/directive-logic/canvas"
    import type { SVGProperties } from "@utils/highlights/directive-logic/svg-canvas"
    import { fade } from "svelte/transition"
    export let showing = false
    export let width: number = 0
    export let height: number = 0
    export let rects: Partial<SVGProperties>[] = []
    export let lines: Partial<SVGProperties>[] = []
    
</script>

{#if showing}
<svg xmlns="http://www.w3.org/2000/svg" in:fade={{duration: 100}} class="absolute left-0 top-0 pointer-events-none" {width} {height} viewBox="0 0 {width} {height}">
    {#each rects as rect}
        <rect style="cursor: pointer; pointer-events: all" {...rect} />
    {/each}
    {#each lines as line}
        <line {...line} />
    {/each}
</svg>
{/if}